import React from 'react'

const Adressicon = () => {


return <svg xmlns="http://www.w3.org/2000/svg" width="14" height="19" viewBox="0 0 14 19" fill="none">
  <path d="M9.5 7C9.5 8.38071 8.38071 9.5 7 9.5C5.61929 9.5 4.5 8.38071 4.5 7C4.5 5.61929 5.61929 4.5 7 4.5C8.38071 4.5 9.5 5.61929 9.5 7Z" stroke="#FFCC03" strokeWidth="1.5"/>
  <path d="M7 0.75C10.3823 0.75 13.25 3.60669 13.25 7.07242C13.25 10.5933 10.3356 13.0642 7.64375 14.7443C7.44757 14.8573 7.22573 14.9167 7 14.9167C6.77427 14.9167 6.55243 14.8573 6.35625 14.7443C3.66937 13.0478 0.75 10.6055 0.75 7.07242C0.75 3.60669 3.61767 0.75 7 0.75Z" stroke="#FFCC03" strokeWidth="1.5"/>
  <path d="M12 15.75C12 16.6705 9.76142 17.4167 7 17.4167C4.23858 17.4167 2 16.6705 2 15.75" stroke="#FFCC03" strokeWidth="1.5" strokeLinecap="round"/>
</svg>
}

export default Adressicon